import {
    notificationToggleComponent,
    NotificationToggleComponent
} from "./enable-notifications/NotificationToggleComponent";

export default function(parentDir: string): string {

    const rootDir = `${parentDir}/components`;

    return angular.module("tfApp.notifications.components", [])
                  .component(NotificationToggleComponent, notificationToggleComponent(rootDir))
                  .name;
}
